import { render, staticRenderFns } from "./BoTag.vue?vue&type=template&id=6648ecc6&scoped=true&"
import script from "./BoTag.vue?vue&type=script&lang=ts&"
export * from "./BoTag.vue?vue&type=script&lang=ts&"
import style0 from "./BoTag.vue?vue&type=style&index=0&id=6648ecc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6648ecc6",
  null
  
)

export default component.exports